import React from 'react';
import { cn } from '@/utils/cn';

interface ContentCalloutCardProps {
  title: string;
  description: React.ReactNode;
  className?: string;
}

const ContentCalloutCard: React.FC<ContentCalloutCardProps> = ({
  title,
  description,
  className,
}) => {
  return (
    <div className={cn(
      'bg-white rounded-xl shadow-sm border border-gray-200 p-8 flex flex-col items-center text-center h-full',
      'transition-all duration-200 hover:shadow-lg',
      'max-w-lg mx-auto w-full',
      className
    )}>
      <h3 className="text-xl font-semibold text-gray-900 mb-4">{title}</h3>
      <div className="text-gray-600">{description}</div>
    </div>
  );
};

interface ContentCalloutProps {
  title: string;
  card: {
    title: string;
    description: string;
  };
  cta: {
    text: string;
    href: string;
  };
  className?: string;
}

const ContentCallout: React.FC<ContentCalloutProps> = ({
  title,
  card,
  cta,
  className
}) => {
  return (
    <section className={cn('py-16', className)}>
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-12">{title}</h2>

        <div className="flex flex-col items-center max-w-5xl mx-auto">
          <ContentCalloutCard
            title={card.title}
            description={
              <p dangerouslySetInnerHTML={{ __html: card.description.replace(/\n/g, '<br />') }} />
            }
          />

          <div className="mt-8 text-center">
            <a
              href={cta.href}
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-600 hover:underline"
            >
              {cta.text}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContentCallout;